import { useTranslation } from "react-i18next";
import { ReservedParticipationType } from "../../../../../autogen/bff-api";

// Reserved participation gets namespaced translation keys so buyer-side labels
// stay decoupled from ESPD taxonomy text.
export const useReservedParticipationLabel = () => {
  const { t } = useTranslation();
  return (value: ReservedParticipationType): string => {
    switch (value) {
      case ReservedParticipationType.None:
        return t("reservedParticipation.NONE");
      case ReservedParticipationType.ShelteredWorkshop:
        return t("reservedParticipation.SHELTERED_WORKSHOP");
      case ReservedParticipationType.PublicServiceMission:
        return t("reservedParticipation.PUBLIC_SERVICE_MISSION");
    }
  };
};
